export enum CheckboxVariant {
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
  CIRCULAR_OUTLINED = 'circularOutlined',
  CIRCULAR_CONTAINED = 'circularContained'
}

export enum CheckboxSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}
